"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getArrayLastElement = void 0;

var getArrayLastElement = function getArrayLastElement(arr) {
  if (Array.isArray(arr)) {
    return arr[arr.length - 1];
  } else {
    throw TypeError("Passed argument is not an array");
  }
};

exports.getArrayLastElement = getArrayLastElement;